import React from "react";
import itFlag from "@assets/images/flags/it.svg";
import gbFlag from "@assets/images/flags/gb.svg";
import frFlag from "@assets/images/flags/fr.svg";
import deFlag from "@assets/images/flags/de.svg";
import esFlag from "@assets/images/flags/es.svg";
import roFlag from "@assets/images/flags/ro.svg";
import alFlag from "@assets/images/flags/al.svg";

const FLAG_MAP: Record<string, string> = {
    it: itFlag,
    gb: gbFlag,
    fr: frFlag,
    de: deFlag,
    es: esFlag,
    ro: roFlag,
    al: alFlag,
};

type FlagIconProps = {
    code?: string;
    alt: string;
    className?: string;
};

export default function FlagIcon({code, alt, className}: FlagIconProps) {
    const src = code ? FLAG_MAP[code.toLowerCase()] : undefined;

    if (!src) {
        return (
            <span className={["lpFlag lpFlag--fallback", className ?? ""].join(" ").trim()} aria-hidden="true">
                {alt.slice(0, 2).toUpperCase()}
            </span>
        );
    }

    return <img src={src} alt={alt} className={["lpFlag", className ?? ""].join(" ").trim()} />;
}